export default "__VITE_ASSET__B3LMSf8l__"